<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <CModal
      :closeOnBackdrop="false"
      :show.sync="modal"
      :no-close-on-backdrop="false"
      :centered="true"
      title=""
      size="lg"
      color="dark"
    >
      <CCard>
        <CCardBody>
          <CAlert
            v-if="alertMsg"
            :color="alertClr"
            closeButton
            fade
          >
            {{ alertMsg }}
          </CAlert>
          <CForm>
            <CInput
              label="所属"
              v-model="inputItems.abbreviation"
              horizontal
              readonly
            />
            <CInput
              label="社員番号"
              v-model="inputItems.user_id"
              horizontal
              readonly
            />
            <CInput
              label="氏名"
              v-model="inputItems.fullname"
              horizontal
              readonly
            />
            <CInput
              label="スキル"
              v-model="inputItems.skill_fullname"
              horizontal
              readonly
            />
            <ValidationProvider
              :rules="`max:${constdata.SKILLINFO_NOTE_MAX_LEN}`"
              v-slot="{ errors }"
              name="備考"
              vid="note"
            >
              <CTextarea
                class="labelsFont"
                rows="5"
                label="備考"
                v-model="inputItems.note"
              ></CTextarea>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </CForm>
        </CCardBody>
      </CCard>
      <template #header>
        <h6 class="modal-title">スキル情報更新</h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton
          @click="remove"
          color="danger"
          :disabled="!hasSkillInfoEditAuthorityProp"
          >削除</CButton
        >
        <CButton
          @click="alertValidation(handleSubmit(update))"
          color="success"
          :disabled="!hasSkillInfoEditAuthorityProp"
          >更新</CButton
        >
      </template>
    </CModal>
  </ValidationObserver>
</template>

<script>
import constMsg from "../../../definition/const/const_message.js";
import constdata from "../../../definition/const/const_userSkill.js";

export default {
  name: "SkillInfoEditModal",
  data() {
    return {
      userInfo: {
        user_id: null,
        fullname: null,
        organization_name: null,
      },
      modal: false,
      alertMsg: "",
      alertClr: "",
      skills: [],
      constdata: constdata,
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
        // 画面表示ONの時、最新データ取得
        if (this.modal) this.fetchData();
      },
    },
  },
  computed: {
    inputItems() {
      return { ...this.data };
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    data: {
      type: Object,
    },
    index: {
      type: Number,
    },
    hasSkillInfoEditAuthorityProp: {
      type: Boolean,
    },
  },
  async mounted() {
    // 初期データ取得
    await this.fetchData();
  },
  methods: {
    closeModal() {
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close");
    },
    alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.observer.validate().then((success) => {
        if (!success) {
          // モーダルを閉じずにバリデーションエラーメッセージを表示
          this.alertClr = "danger";
          this.alertMsg =
            "入力内容に不備があります。詳細は各項目を確認してください。";
          // モーダルトップへスクロール
          this.$refs["modal-title"].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    },
    async update() {
      var param = {
        user_id: this.inputItems.user_id,
        skill_id: this.inputItems.skill_id,
        note: this.inputItems.note,
        login_user_id: this.inputItems.login_user_id,
      };
      // 更新処理
      const ret = await this.updateSkillInfo(param);
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // クローズ処理
      this.modal = false;
      this.$emit("close", ret);
    },
    async updateSkillInfo(param) {
      let ret = {};
      await this.$axios
        .put(
          "/api/v1/userskills/" + param.user_id + "/" + param.skill_id,
          param
        )
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0003_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
    async remove() {
      var param = {
        user_id: this.inputItems.user_id,
        skill_id: this.inputItems.skill_id,
      };
      // 削除処理
      const ret = await this.deleteSkillInfo(param);

      if (ret.status === 204) {
        ret.alertClr = "success";
        ret.alertMsg = constMsg.I0004_JP;

        // 得意技術から削除対象スキルが削除されている場合、ポップアップを表示する
        this.showDeletedStrengthSkillMsg(ret.headers.deleted_strength_skill_id);
      } else {
        ret.alertClr = "danger";
        ret.alertMsg = ret.response.data.message;
      }
      // クローズ処理
      this.modal = false;
      this.$emit("close", ret);
    },
    async deleteSkillInfo(param) {
      let ret = {};
      await this.$axios
        .delete("/api/v1/userskills/" + param.user_id + "/" + param.skill_id, {
          data: param,
        })
        .then((res) => {
          ret = res;
        })
        .catch((e) => {
          ret = e;
          ret.status = e.response.status;
        });
      return ret;
    },
    async fetchData() {
      // ログインユーザー情報セット
      var loginUser = await this.getUserInfo(
        this.$store.state.loginUser.user_id
      );
      this.userInfo.user_id = loginUser.user_id;
      this.userInfo.fullname = `${loginUser.lastname} ${loginUser.firstname}`;
      this.userInfo.organization_name =
        loginUser.m_organization.organization_name;
    },
    async getUserInfo(id) {
      let ret = null;
      await this.$axios
        .get("/api/v1/users/" + id)
        .then((res) => {
          ret = res.data.users;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
        });
      return ret;
    },
    showDeletedStrengthSkillMsg(deleted_strength_skill_id) {
      // 得意技術から削除対象スキルが削除されている場合、ポップアップを表示する
      if (deleted_strength_skill_id != "") {
        // バックエンドから渡されたスキルIDを基にスキル名称+スキルバージョンを取得しメッセージを作成
          var deleted_strength_skill_msg = constMsg.I0005_JP.format(
            this.inputItems.skill_fullname
          );
        this.$emit("showMessage", deleted_strength_skill_msg);
      }
    },
  },
};
</script>
